export const CArticleMastheadFragments = {
  field: `
    fragment articleMasthead on articleMasthead_MatrixField {
      ... on articleMasthead_block_Entry {
        id
        typeHandle
        idName
        heading
        image {
          url
          title
          hasFocalPoint
          focalPoint
        }
        imageMobile {
          url
          title
          hasFocalPoint
          focalPoint
        }
      }
    }
  `,
}
